import React from 'react';
import loadable from '@loadable/component';
import LoadingScreen from 'components/LoadingScreen';

const LoadableUnifiedCheckoutHome = loadable(
  () => import('./UnifiedCheckoutHome'),
  {
    fallback: <LoadingScreen />,
  },
);

const UnifiedCheckoutHomeError = loadable(() => import('./Error'), {
  fallback: <LoadingScreen />,
});

export default LoadableUnifiedCheckoutHome;
export { UnifiedCheckoutHomeError };
